import styled from "styled-components";
import {
  labelColor,
  regularFont,
  inputBorderColor,
  inputBackgroundColor,
  whiteColor,
} from "@app/styles";
type Props = {
  disabled?: boolean;
};
export const BoyImageContainer = styled.div`
  z-index: 1;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          cursor: not-allowed;
          button{
            background-color:rgb(236 236 236 / 50%);
            pointer-events:none;
            color:${labelColor};
          }
      `;
    }
  }}
`;

export const AddButtonContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  margin-top: 30%;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          cursor: not-allowed;
          button{
            background-color:rgb(236 236 236 / 50%);
            pointer-events:none;
            color:${labelColor};
          }
      `;
    }
  }}
`;

export const SuccessContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &.student_success {
    margin-top: -30px;
    svg {
      width: 150px;
      height: 150px;
    }
  }
`;

export const SuccessHeading = styled.div`
  margin-top: 20px;
  font-size: 21px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.04em;
  color: #32bea6;
  ${regularFont};
`;
export const SuccessText = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0.035em;
  color: ${labelColor};
  ${regularFont};
  margin: 8px 0 24px;
`;

export const SampleContainer = styled.div`
  min-height: 50vh;
  max-height: 70vh;
  overflow-y: auto;
`;

export const SampleTextBox = styled.div`
  background-color: #f7f7f7;
  border: 2px solid ${inputBorderColor};
  box-sizing: border-box;
  border-radius: 6px;
  padding: 16px;
  min-height: 44px;
  font-size: 14px;
  font-weight: 300;
  font-family: "Poppins", sans-serif;
  resize: none;
  line-height: 28px;
  letter-spacing: 0.035em;
  color: ${labelColor};
`;
export const Value = styled.div`
  font-size: 14px;
  font-weight: 300;
  font-family: "Poppins", sans-serif;
  resize: none;
  line-height: 28px;
  letter-spacing: 0.035em;
  color: ${labelColor};
`;


export const StudentDetailWrapper = styled.div`
background-color: transparent;
border: 1px solid ${inputBorderColor};
border-radius: 8px;
padding: 16px;
position: relative;
&:not(:last-child){
  margin-bottom: 16px;
}
`

export const StudentTableWrapper = styled.div`
width: 100%;
height: 500px;
display: flex;
flex-direction: column;
&.h-unset{
  height: unset;
}
&.bordered{
  border: 1px solid ${inputBorderColor};
}
&.br-6{
  border-radius: 6px;
}
`

export const StudentTableHeader = styled.div`
width: 100%;
height: 40px;
display: flex;
align-items: center;
padding: 0 16px 0 8px;
border-bottom: 1px solid ${inputBorderColor};
&.alt-padding{
  padding: 0 16px;
}
`

export const StudentTableColumn = styled.div`
min-width: 30%;
width: 30%;
overflow: hidden;
&.w-5{
  min-width: 5%;
  width: 5%;
}
&.w-8{
  min-width: 8%;
  width: 8%;
}
&.actions-column{
  width: 16%;
  min-width: 16%;
}
&.flexed{
  flex: 1;
  width: unset;
  min-width: unset;
}
&:not(:last-child){
  padding-right: 16px;
}
p{
  line-height: 1.5;
}
.custom-password-field{
  > div{
    margin:0 !important;
  }
}
.showPasswordContainer{
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`

export const StudentTableContentHolder = styled.div`
flex: 1;
overflow: hidden;
border-bottom: 1px solid ${inputBorderColor};
&.alt{
  border: none;
}
&.no-border{
  border: none;
}
`


export const StudentTableContent = styled.div`
height: 100%;
overflow: auto;
padding: 8px 8px 8px 0;
display: flex;
flex-direction: column;
position: relative;
&.alt-padding{
  padding: 8px 0;
}
&.p-1{
  padding: 8px;
}
&.min-height{
  min-height: 250px;
}
.nochild{
  padding: 20px 0;
  text-align: center;;
}
`

export const StudentDetailsWrapper = styled.div`
width: 100%;
min-height: 46px;
background-color: #f7f7f7;
border-radius: 6px;
padding: 8px;
display: flex;
align-items: center;
&:not(:last-child){
  margin-bottom: 8px;
}
&.has-input{
  min-height: 60px;
  align-items: flex-start;
}
`

export const ActionsHolder = styled.span`
display: flex;
padding: 0 8px;
cursor: pointer;
opacity: 0.85;
transition: all 0.3s ease;
&:hover{
  opacity: 1;
}
&.mt-10{
  margin-top: 10px;
}
`

export const StudentsTableWrapper = styled.div`
  min-height: 100px;
  max-height: 500px;
  overflow: auto;
  table{
    border-collapse: collapse;
    margin-left: auto;
    margin-right: auto;
  }
  table{
    thead{
      position: sticky;
      top: 0;
      left: 0;
      background-color: ${whiteColor};
      tr{
        position: relative;
        &::after{
          content: '';
          width: 100%;
          height: 2px;
          background-color: ${inputBorderColor};
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    thead tr, tbody tr {
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 4px solid #fff;
    }
    td, th{
      width: 180px;
      padding: 0 16px;
      font-size: 16px;
      font-weight: 500;
      word-break: break-word;
      &.w-250{
        width: 250px;
      }
      &.w-unset{
        width: unset;
      }
      &.w-275{
        width:275px;
      }
      &.w-300{
        width:300px;
      }
      &.w-40{
        width:40px;
      }&.w-60{
        width:60px;
      }
      &.pb-30{
        padding-bottom:30px;
      }
      &.w-160{
        width:160px;
      }
    }
    th{
      padding-top: 12px;
      padding-bottom: 12px;
      font-family: 'Filson';
    }
    tr{
      td{
        min-height: 50px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        font-size: 14px;
        line-height: 1.5;
        &:first-child{
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        &:last-child{
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }
      &.has-inputs{
        td{
          min-height: 90px;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
      }
    }
  }
`

export const GoogleSyncButton = styled.div`
  margin: 10px;
  text-align: center;
`